import { Box, Container, Grid, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { varFadeIn as FadeIn } from "../../theme/fadein"; // Ajuste o caminho se necessário
import MotionInView from "../../theme/MotionView"; // Ajuste o caminho se necessário

export default function GonewFooter() {
  const theme = useTheme();

  const metrics = [
    {
      value: "+100 MIL",
      label: "Pessoas na Comunidade",
    },
    {
      value: "+5 MIL",
      label: "Certificados de Alta Gestão",
    },
    {
      value: "+500",
      label: "Empresas Apoiadas",
    },
    {
      value: "+180",
      label: "Cofundadores Intelectuais",
    },
    {
      value: "+30",
      label: "Livros e Ferramentas Construídas Coletivamente",
    },
    {
      value: "+7 MILHÕES",
      label:
        "de Impactos em Movimentos como #AcademiadeSocios #SpeedSomeControl #GoverneSeuNegocio #StartupsVsCovid19",
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[900] || "#161C24", // Cor de fundo escura
          borderTop: `1px solid ${theme.palette.grey[800]}`,
          py: { xs: 6, md: 8 },
          px: 2,
        }}
      >
        <Container maxWidth="lg">
          <MotionInView variants={FadeIn}>
            <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
              <img
                src="/static/logos/gonew-community.png"
                alt="Logo Gonew Community"
                style={{
                  maxWidth: 300,
                }}
              />
              <Typography
                variant="body1"
                fontSize={18}
                sx={{
                  color: "white",
                  mt: 1.5,
                  maxWidth: "580px",
                  mx: "auto",
                }}
              >
                Somos uma comunidade de{" "}
                <Typography
                  component="span"
                  fontSize={18}
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  alta gestão
                </Typography>
                .<br />
                Construímos coletivamente{" "}
                <Typography
                  component="span"
                  fontSize={18}
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  saberes e movimentos
                </Typography>
                .
              </Typography>
            </Box>
          </MotionInView>

          <Grid container spacing={{ xs: 4, md: 5 }}>
            {metrics.map((metric, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <MotionInView variants={FadeIn}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h3"
                      component="p"
                      sx={{
                        fontWeight: "bold",
                        color: "#FACC15",
                        fontSize: "46px !important",
                      }}
                    >
                      {metric.value}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "grey.500",
                        minHeight: { sm: 40 },
                        fontSize: 16,
                      }}
                    >
                      {metric.label}
                    </Typography>
                  </Box>
                </MotionInView>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
}
